import LineChartComponent from './line-chart';
import withSelectedTimeZone from './withSelectedTimeZone';

const LineChart = withSelectedTimeZone(LineChartComponent);

export default LineChart;
export { LineChart };
